import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import PaymentDueBodyItems from "./PaymentDueBodyItems";
import "./MyTable.css";
import PaymentDueBeatBodyItems from "./PaymentDueBeatBodyItems";

const options = {
  sortIndicator: true,
  hideSizePerPage: false,
  paginationSize: 3,
  hidePageListOnlyOnePage: false,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
};

export default function PaymentDueBeatBody({
  data,
  showSales,
  hide,
  Onback,
  items,
}) {
  const sum = data.lenght > 0 ? data.reduce((a, b) => (a.balance + b, 0)) : 0;
  const cellButton = (cell, row, enumObject, rowIndex) => {
    return (
      <span>
        {row.salesPersonName != "Total" ? (
          <div>
            <Button
              className="btn btn-warning"
              id={`view-${row.id}`}
              onClick={(e) => showSales(row)}
              style={{ marginLeft: "5px" }}
              key={row.id}
            >
              <i className="fa fa-eye" />
            </Button>

            <UncontrolledTooltip placement="right" target={`view-${row.id}`}>
              view
            </UncontrolledTooltip>
          </div>
        ) : null}
      </span>
    );
  };

  const rowClassNameFormat = (row, rowIdx) => {
    // row is whole row object
    // rowIdx is index of row
    return row.salesPersonName === "Total" ? "tr-odd" : "tr-even";
  };

  return (
    <div>
      <Card>
        <CardHeader className="carheaderSmall">
          <strong>Beat Payment Due</strong>
        </CardHeader>

        <CardBody>
          <Card color="primary">
            <CardBody>
              <Row>
                <Col>
                  <CardTitle tag="h4">Total </CardTitle>
                </Col>
                <Col>
                  <CardTitle tag="h5">
                    {data.reduce(
                      (n, item) =>
                        n +
                        Number(
                          item.balance.substring(0, item.balance.length - 6)
                        ),
                      0
                    )}{" "}
                    lakhs
                  </CardTitle>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {hide ? (
            <BootstrapTable
              data={data}
              version="4"
              condensed={true}
              striped
              hover
              pagination
              search
              options={options}
              exportCSV
              csvFileName="Payment_Due_beat.csv"
              trClassName={rowClassNameFormat}
            >
              <TableHeaderColumn
                isKey
                dataField="id"
                export={false}
                hidden={true}
              >
                ID
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="beatName"
                csvHeader="beatName"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Beat name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="balance"
                csvHeader="totalDue"
                filter={{ type: "TextFilter", delay: 1000 }}
                dataSort
                tdStyle={{ whiteSpace: "normal" }}
                thStyle={{ whiteSpace: "normal" }}
              >
                Total Due
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="button"
                dataFormat={cellButton}
                hiddenOnInsert
                export={false}
              >
                Actions
              </TableHeaderColumn>
            </BootstrapTable>
          ) : (
            <PaymentDueBeatBodyItems data={items} onBack={Onback} />
          )}
        </CardBody>
      </Card>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/PaymentDueBeatBody.js